import { Button } from "@/components/Base/Button";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useVersionCheck } from "@/hooks/useVersionCheck";
import { useStore } from "@/stores/useStore";
import { Icon } from "@/components/Common/Icon";

export const NewVersionAvailableDialog = () => {
  const { subscribeAppInfo } = useStore();
  const { latestAppVersion, newVersionAvailable } = useVersionCheck();
  const latestDismissedVersion = document.cookie
    .split(";")
    .find((c) => c.trim().startsWith("version_check_dismissed_version="))
    ?.split("=")[1];

  const shouldShowDialog = useMemo(() => {
    return newVersionAvailable && latestDismissedVersion !== latestAppVersion;
  }, [newVersionAvailable, latestDismissedVersion, latestAppVersion]);

  const [open, setOpen] = useState(shouldShowDialog);
  const handleOpenChange = () => {
    setOpen(!open);
    document.cookie = `version_check_dismissed_version=${latestAppVersion}; max-age=86400;`;
  };

  const handleDismiss = async () => {
    handleOpenChange();
  };

  const handleReload = () => {
    handleOpenChange();
    window.location.reload();
  };

  const appListenerCallback = useCallback(
    () => subscribeAppInfo(),
    [subscribeAppInfo]
  );

  useEffect(() => {
    appListenerCallback();
  }, [appListenerCallback]);

  useEffect(() => {
    setOpen(shouldShowDialog);
  }, [shouldShowDialog]);

  if (!shouldShowDialog) return null;

  return (
    <div
      className={
        "absolute bottom-0 left-0 z-50 flex w-64 flex-col gap-1 rounded-tr-2xl bg-black bg-opacity-50 p-3 text-left text-white"
      }
    >
      <Button
        size={"tinyIcon"}
        onClick={() => handleDismiss()}
        className={"absolute right-0 top-0 mr-1 mt-1"}
      >
        <Icon name={"clear"} size={12} />
      </Button>
      <div className={"text-sm"}>Update Available!</div>
      <div className={"text-xs"}>
        {latestAppVersion} is available. Reload the window to get the latest
        features.
      </div>

      <div className={"mt-2 flex flex-row justify-between"}>
        <Button
          size={"sm"}
          onClick={() => handleDismiss()}
          variant={"ghost-alt"}
          className={"hover:bg-primary/80"}
        >
          Dismiss
        </Button>
        <Button
          size={"sm"}
          onClick={() => handleReload()}
          variant={"ghost-alt"}
          className={"hover:bg-primary/80"}
        >
          Reload
        </Button>
      </div>
    </div>
  );
};
